export default __webpack_public_path__ + "static/media/640_dummy2016-consulting01-de.9ed93fbb.png";